export interface PlanLimits {
  jobs?: number
  users?: number
  storage?: number
}

export interface Plan {
  id: string
  name: string
  description: string
  price: number
  billingPeriod: 'month' | 'year' | 'week'
  features: string[]
  limits?: PlanLimits
  popular: boolean
  active: boolean
  order: number
}

class PlansService {
  private plans: Plan[] = [
    {
      id: '1',
      name: 'Starter',
      description: 'Perfect for individual contractors',
      price: 29,
      billingPeriod: 'month',
      features: [
        'Job marketplace access',
        'Basic scheduling',
        'Digital timesheets',
        'Expense tracking',
        'Mobile app access'
      ],
      limits: {
        jobs: 10,
        users: 1,
        storage: 5
      },
      popular: false,
      active: true,
      order: 1
    },
    {
      id: '2', 
      name: 'Professional',
      description: 'Ideal for growing contractors',
      price: 79,
      billingPeriod: 'month',
      features: [
        'Everything in Starter',
        'Advanced scheduling',
        'Team management',
        'Compliance tracking',
        'Priority support',
        'Custom reporting'
      ],
      limits: {
        jobs: 50,
        users: 5,
        storage: 25
      },
      popular: true,
      active: true,
      order: 2
    },
    {
      id: '3',
      name: 'Enterprise',
      description: 'For large operations and companies',
      price: 199,
      billingPeriod: 'month',
      features: [
        'Everything in Professional',
        'Unlimited jobs',
        'Unlimited team members',
        'Advanced analytics',
        'API access',
        'Dedicated support',
        'Custom integrations'
      ],
      limits: {
        jobs: -1,
        users: -1,
        storage: -1
      },
      popular: false,
      active: true,
      order: 3
    }
  ]

  // Get all plans
  async getAllPlans(): Promise<Plan[]> {
    // TODO: Replace with actual API call
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([...this.plans])
      }, 100)
    })
  }

  // Get active plans for public display
  async getActivePlans(): Promise<Plan[]> {
    // TODO: Replace with actual API call
    return new Promise((resolve) => {
      setTimeout(() => {
        const activePlans = this.plans
          .filter(plan => plan.active)
          .sort((a, b) => a.order - b.order)
        resolve(activePlans)
      }, 100)
    })
  }

  // Create new plan
  async createPlan(planData: Omit<Plan, 'id'>): Promise<Plan> {
    // TODO: Replace with actual API call
    return new Promise((resolve) => {
      setTimeout(() => {
        const newPlan: Plan = {
          ...planData,
          id: Date.now().toString()
        }
        this.plans.push(newPlan)
        resolve(newPlan)
      }, 100)
    })
  }

  // Update existing plan
  async updatePlan(id: string, planData: Partial<Plan>): Promise<Plan> {
    // TODO: Replace with actual API call
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const index = this.plans.findIndex(p => p.id === id)
        if (index !== -1) {
          this.plans[index] = { ...this.plans[index], ...planData }
          resolve(this.plans[index])
        } else {
          reject(new Error('Plan not found'))
        }
      }, 100)
    })
  }

  // Delete plan
  async deletePlan(id: string): Promise<void> {
    // TODO: Replace with actual API call
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const index = this.plans.findIndex(p => p.id === id)
        if (index !== -1) {
          this.plans.splice(index, 1)
          resolve()
        } else {
          reject(new Error('Plan not found'))
        }
      }, 100)
    })
  }

  // Update plan status
  async updatePlanStatus(id: string, active: boolean): Promise<void> {
    // TODO: Replace with actual API call
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const plan = this.plans.find(p => p.id === id)
        if (plan) {
          plan.active = active
          resolve()
        } else {
          reject(new Error('Plan not found'))
        }
      }, 100)
    })
  }
}

export const plansService = new PlansService()
